<template>
  <div class="container">
    <mt-header fixed title="工程管理" class="head" >
      <!--<div class="searchIcon" slot="left" v-show="auth.isTab && selected==1" @click="toSearch">-->
        <!--<i class="iconfont icon-fangdajing1"></i>-->
      <!--</div>-->
      <mt-button v-show="auth.isCalendar" slot="right" class="iconfont icon-calendar" @click.native="openorclose">
      </mt-button>
    </mt-header>
    <div class="box" v-show="auth.isCalendar&&isShowdate">
      <section class="date">
        <div class="c_flex c_flex_between c_flex_center c_white c_p_10">
          <div class="prev" @click="prevClick">上一月</div>
          <div class="tomon" @click="todayClick"><span class="year">{{calendar.year}}</span>年 <span class="month">{{calendar.month}}</span>月</div>
          <div class="next"  @click="nextClick">下一月</div>
        </div>
        <ol class="c_flex c_flex_center" style="flex-wrap:wrap;">
          <li class="c_flex c_flex_center">周日</li>
          <li class="c_flex c_flex_center">周一</li>
          <li class="c_flex c_flex_center">周二</li>
          <li class="c_flex c_flex_center">周三</li>
          <li class="c_flex c_flex_center">周四</li>
          <li class="c_flex c_flex_center">周五</li>
          <li class="c_flex c_flex_center">周六</li>
        </ol>
        <ul class="c_flex" style="flex-wrap:wrap;">
          <li @click="getSearchClick(item)" class="c_rela c_flex c_flex_center" :class="item.on?'on bg_orange':(item.date?'':'c_gray c_no_pointer')" v-for="(item,index) in dateList" :data-date="item.date" :key="index">
            <div :class="item.is=='Y'?'sch':''">{{item.num}}</div>
            <span class="bg_orange" v-if="item.is=='Y'"></span>
          </li>
        </ul>
      </section>
      <div style="height: 36vh;"></div>
    </div>
    <div class="select"  v-show="auth.isTab && !isShowdate">
      <mt-navbar v-model="selected">
        <mt-tab-item id="0" data-id="0" @click.native="filterClick">待接单</mt-tab-item>
        <mt-tab-item id="1" data-id="1" @click.native="filterClick">施工中</mt-tab-item>
        <mt-tab-item id="2" data-id="2" @click.native="filterClick">已完工</mt-tab-item>
      </mt-navbar>
      <div style="height:7.5vh;"></div>
    </div>
    <div class="sort" v-show="!isShowdate && (selected==1) && sort.isShowSort && auth.isTab">
      <div class="sort-body bg_white">
        <div class="sort-condition c_flex ">
          <div class="sort-condition-group" :class="sort.select==1?'et':''" @click="selectSort(1)">工程状态 ：{{sort.state}}</div>
          <div class="sort-condition-group" :class="sort.select==2?'et':''" @click="selectSort(2)">时间 ：{{sort.time}}</div>
          <div class="sort-condition-group" :class="sort.select==3?'et':''" @click="selectSort(3)">
            <i class="iconfont icon-fangdajing1" style="font-size: 3vw"></i> ：{{sort.search||'点击输入'}}
          </div>
          <div class="sort-condition-group" :class="sort.select==4?'et':''" @click="selectSort(4)">排序规则 ：{{sort.orderbytime}}</div>
        </div>
        <div class="sort-extends" v-show="sort.isShowSort && sort.select">
          <div class="sort-extends-bg" @click="closeSort"></div>
          <div class="sort-extends-body c_flex" v-show="sort.select==1" :style="sort.select==1?'height: 65vw;':'height: 15vw;'">
            <div v-for="(n,index) in arrState" :key='index' class="sort-extends-group" :class="n.name==sort.state?'on':''" @click="extendsSelect('state',n.name,n.num)">
              <i class="iconfont icon-duigou1 c_m_r_10" :class="n.name==sort.state?'c_red':'c_gray'"></i> {{n.name}}
            </div>
          </div>
          <div class="sort-extends-body c_flex" v-show="sort.select==2" :style="sort.select==2?'height: 65vw;':'height: 15vw;'">
            <div v-for="(n,index) in arrTime" :key='index' class="sort-extends-group" :class="n.name==sort.time?'on':''" @click="extendsSelect('time',n.name,n.num)">
              <i class="iconfont icon-duigou1 c_m_r_10" :class="n.name==sort.time?'c_red':'c_gray'"></i> {{n.name}}
            </div>
          </div>
          <div class="sort-extends-body c_flex" v-show="sort.select==3" :style="sort.select==3?'height: 15vw;':'height: 65vw;'">
            <!--<div v-for="(n,index) in arrTime" :key='index' class="sort-extends-group" :class="n.name==sort.time?'on':''" @click="extendsSelect('time',n.name,n.num)">-->
              <!--<i class="iconfont icon-duigou1 c_m_r_10" :class="n.name==sort.time?'c_red':'c_gray'"></i> {{n.name}}-->
            <!--</div>-->
            <div class="c_rela c_w c_box c_p_10">
              <input type="text" class="sort-extends-input" placeholder="输入姓名、手机号搜索" v-model="sort.search">
            </div>
          </div>
          <div class="sort-extends-body c_flex" v-show="sort.select==4" :style="sort.select==4?'height: 65vw;':'height: 15vw;'">
            <div v-for="(n,index) in arrOrderBy" :key='index' class="sort-extends-group" :class="n.name==sort.orderbytime?'on':''" @click="extendsSelect('orderbytime',n.name,n.num)">
              <i class="iconfont icon-duigou1 c_m_r_10" :class="n.name==sort.orderbytime?'c_red':'c_gray'"></i> {{n.name}}
            </div>
          </div>
          <div class="sort-extends-opera c_flex c_flex_center" :style="sort.select==3?'top:15vw;':''">
            <div class="c_flex c_flex_center" @click="resetSort">重置</div>
            <div class="bg_blue c_white c_flex c_flex_center" @click="saveSort">确定</div>
          </div>
        </div>
      </div>
      <div style="height: 7vh;"></div>
    </div>
    <div class="loadmore-container">
      <!--<mt-loadmore :top-method="loadTop" ref="loadmore" :bottom-method="loadBottom"  :bottomDropText="params.bottomDropText"  :bottom-all-loaded="allLoaded">-->
      <mt-loadmore :top-method="loadTop" ref="loadmore" v-infinite-scroll="scroll_load" :infinite-scroll-disabled="loading" infinite-scroll-distance="1">
        <div v-for="(n,index) in list" :key='index' class="c_rela c_m_t_10 bg_white form" @click="todetails(n)">
          <!--待接单-->
          <div class="c_size_11 c_flex_1 c_nowrap" v-if="Number(n.servicestate)==0">
            <div class="new">最新</div>
            <div class=" c_size_12 c_black code c_p_lr">{{n.vbillcode}} </div>
            <!--<div class="c_m_t_10">工程状态：<span :class="(n.servicestate==1?'c_blue':'c_gray')">{{n.servicestate==0?'待接单':(n.servicestate==2?'已完工':'施工中')}}</span></div>-->
            <div class="c_nowrap c_m_t_10  c_p_lr" v-show="n.servicestate != 0 && (n.name || n.contactname)">姓名：{{n.contactname || n.name}}</div>
            <div class="c_nowrap c_m_t_10  c_p_lr c_flex">
              <span class="c_gray_dark">地址：</span>
              <span class="c_black c_flex_1 c_nowrap_normal">{{n.province}}{{n.city}}{{n.district}}{{n.address}}</span>
              <span class="c_gray" v-if='n.community'></span>
              <!--<span  v+-show="n.community" class="c_gray_dark">小区：</span><span v-show="n.community" class="c_black">{{n.community}}</span>-->
            </div>
            <!--维修部位 面积 计划工期-->
             <div class="c_nowrap c_m_t_10 c_p_lr" v-if='n.part || n.area'>
                  <span class="c_gray_dark" v-if='n.part'>维修部位：</span><span class="c_black" v-if='n.part'>{{n.part}}</span><span class="c_gray" v-if='n.area&&n.part'>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                  <span class="c_gray_dark" v-if='n.area'>面积：</span><span class="c_black" v-if='n.area'>{{n.area}}㎡</span><span class="c_gray"  v-if="n.servicestate==1 && n.planneddate">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span >
                  <span class="c_gray_dark" v-if="n.servicestate==1 && n.planneddate">计划工期：</span>
                  <span v-if="n.servicestate==1 && n.planneddate" class="c_black">{{ n.planneddate}} 天</span>
              </span>
              </div>
              <!--创建时间 勘察时间-->
            <div class="c_nowrap c_m_t_10 c_flex_between c_p_lr">
              <span><span class="c_gray_dark">创建：</span><span class="c_black">{{ n.createtime | getDatetime }}</span></span>
              <span><span class="c_gray_dark" v-show="selected<1 && n.surveydate">勘察：</span><span class="c_black" v-show="selected<1 && n.surveydate">{{ n.surveydate | getDatetime }}</span></span>
            </div>
          </div>
          <!--施工中-->
          <div class="c_size_12 c_flex_1 c_nowrap info" v-else>
            <div class="c_size_15">
              <span class="">{{n.vbillcode}}</span>
            </div>
            <div class="c_size_15 c_black c_nowrap c_m_t_10" v-show="n.servicestate != 0 && (n.contactname || n.name)">
              {{n.contactname || n.name}}
              <span class="state_bg" :class="'state_'+n.note">
                {{n.note==1?'待分配': n.note==2?'已拒绝': n.note==3?'已接单': n.note==4?'未上门': n.note==5?'已上门': n.note==6?'已报价': n.note==7?'已下单': n.note==8?"施工中" : n.note==9? "在施工" : n.note==11? "已完工":""}}
              </span>
            </div>
            <div class="c_nowrap c_m_t_10 c_black" v-show="n.servicestate != 0 && (n.contactphone || n.phone)">手机号码：{{n.contactphone || n.phone}}</div>
            <div class="c_nowrap c_m_t_10 c_black" v-if="Number(n.servicestate)==-2 || Number(n.servicestate)==-3">
              工程状态：{{n.servicestate | filter_servicestate}}
            </div>
            <div class="c_flex c_m_t_10 c_black">
              <span>施工地址：</span>
              <span class="c_flex_1 c_nowrap_normal">{{n.province}}{{n.city}}{{n.district}}{{n.address}}</span>
            </div>
            <div class="c_nowrap c_m_t_10 c_gray_drak planeDate">计划工期：{{ n.startdate | getYmd }} - {{ n.planneddate | getYmd}} </div>
          </div>
          <div class="c_gray c_m_t_10" v-if="n.allotNote && (Number(n.servicestate) == 0)">
            工单动态：{{n.allotNote}}
          </div>
          <div class="opera c_flex c_flex_center" v-if="Number(n.servicestate) == 0">
            <div class='confirm'>
              <div style='float:left'><span class="c_orange">待接单</span></div>
              <div class="bg_gray c_white" @click="acceptClick('N',n.billid)">拒绝</div>
              <div class="bg_blue c_white" @click="acceptClick('Y',n.billid)">接受</div>
            </div>
          </div>
          <div class="around c_flex supper" v-else>
            <div class="c_m_r_10 bg_gray_light c_white" v-if="n.supervisor">{{n.supervisor.charAt(0)}}</div>
            <div class="c_m_r_10 bg_gray_light c_white" v-if="n.constructionname">{{n.constructionname.charAt(0)}}</div>
          </div>

        </div>

        <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="list.length<1 && (!loading) && (!showLoading)">
          <div class="c_gray" v-if="isShowdate">您当天没有工程</div>
          <div class="c_gray" v-else>
            {{selected==0?'您没有待接单工程':(selected==2?'您没有已完工工程':'您没有施工中工程')}}
          </div>
        </div>
        <div class="c_size_10 c_gray c_p_10 c_center c_flex c_flex_center" v-show="showLoading">
          <mt-spinner type="snake" color="#00ccff" :size="20" v-show="!stopload"></mt-spinner>
          <span v-show="stopload">已经是最后一页了</span>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>
<script>
  import { Indicator } from 'mint-ui';
  export default {
    data(){
      return{
        list:[],
        allLoaded:false,
        isShowdate:false,
        selected:'0',
        params:{
          pageIndex:0,
          pageSize:5,
          totalPages:1,
          date:'',
          month:this.getToday('','month'),
          servicestate:0,   // 施工中 1 ， 已完工 2
          bottomDropText:'释放加载',
        },
        dateList:[],
        importantList:[],
        calendar:{
          year:'',
          month:'',
        },
        //sort
        sort:{
          isShowSort:true,
          isShowSearch:true,
          select:0,
          state:'全部',
          stateNum:-1,
          time:'全部',
          timeNum:-1,
          search:'',
          orderbytime:'建单时间',
          orderbytimeNum:-1
        },
        arrState:[
          /**
           * "1"待分配;"2"已拒绝;"3"已接单;"4"未上门;"5"已上门;"6"已报价;"7"已下单;"8"施工中
           */
          {name:'待分配',num:1},
          {name:'已拒绝',num:2},
          {name:'已接单',num:3},
          {name:'未上门',num:4},
          {name:'已上门',num:5},
          {name:'已报价',num:6},
          {name:'已下单',num:7},
          {name:'施工中',num:8},
          {name:'在施工',num:9},
          {name:'已完工',num:11}
        ],
        arrTime:[
          {name:"近7天",num:1},
          {name:"近15天",num:2},
          {name:"本月",num:3},
          {name:"上个月",num:4},
        ],
        arrOrderBy:[
          {name:"建单时间",num:-1},
          {name:"分配管家时间",num:1},
        ],
      // 无限滚动
        loading:false,
        showLoading:false,
        stopload:false,
        // 功能权限控制
        auth:{
          // 是否可以使用日历筛选
          isCalendar:false,
          // 是否显示 tab切换
          isTab:false,
        },
        //禁止多次提交
        acceptBool:true,
      }
    },

    mounted:function(){
        this.$indicator.close();
        var selected = localStorage['selected']||"0";
        this.selected = selected;
        this.params.servicestate = selected;
        this.getSort();
        // this.loadList();
        if(localStorage['userinfo']){
          var obj = JSON.parse(localStorage['userinfo']);
          var usertype = obj.usertype;
          if(usertype == 'customer'){
            this.auth.isCalendar = false;
            this.auth.isTab = false;
            this.params.servicestate = 1;
            // this.selected = 1;
          }else{
            this.auth.isCalendar = true;
            this.auth.isTab = true;
          }
        }else{
          this.$comm.goLogin();
        }
    },
    methods:{
      loadList:function(fun){
          var $that = this;
          this.$indicator.open();
          let starttime,endtime,note,userinfo,orderbytime;
          if(this.selected==1){
            note = $that.sort.stateNum;
            userinfo = $that.sort.search;
            if(this.sort.timeNum>0){
              var timeObj = this.sortTimeFilter(this.sort.timeNum);
              starttime = timeObj.starttime;
              endtime = timeObj.endtime;
            }else{
              starttime = '';
              endtime = '';
            }
            orderbytime = $that.sort.orderbytimeNum;
          }
          this.$ajax.get(this.$$api.mobile.getServiceList,{
            'pageIndex':$that.params.pageIndex,
            'pageSize':$that.params.pageSize,
            'sortDirection':'desc',
            'sortField':'ts',
            'search_date':$that.params.date,
            'search_servicestate':$that.params.servicestate,
            'search_userinfo':userinfo,
            'search_note':note,
            'search_starttime':starttime,
            'search_endtime':endtime,
            'search_orderbytime':orderbytime,
          },function (res) {
            if (res.status == 200) {
                var msg = res.data.detailMsg.data;
                var pageIndex = msg.number;
                var totalPages = msg.totalPages;
                var list = msg.content;
                if(pageIndex==0){
                  //工期结束时间是开始时间+计划工期,如果没有计划工期,默认计划工期为15天
                  for( var item of list){
                    var startdate = item.startdate;
                    var planneddate = item.planneddate;
                    if(!planneddate){
                      planneddate = new Date(startdate).getTime() + parseInt(15*24*60*60*1000);
                    }
                    item.planneddate = planneddate;
                  }
                  $that.list = list;
                }else if(pageIndex < totalPages){
                  //工期结束时间是开始时间+计划工期,如果没有计划工期,默认计划工期为15天
                  for( var item of list){
                    var startdate = item.startdate;
                    var planneddate = item.planneddate;
                    if(!planneddate){
                      planneddate = new Date(startdate).getTime() + parseInt(15*24*60*60*1000);
                    }
                    item.planneddate = planneddate;
                  }
                  $that.list = $that.list.concat(list);
                }
                $that.params.pageIndex = pageIndex+1;
                $that.params.totalPages = totalPages;
            }
            if(fun)fun();
            $that.$indicator.close();
            $that.loading = false;
          });
      },
      loadTop:function(){
        var $that = this;
        this.params.bottomDropText = '释放加载';
        this.params.pageIndex = 0;
        this.loadList(function () {
          setTimeout(function () {
            $that.$refs.loadmore.onTopLoaded();
          })
        });
      },
      loadBottom:function(){
        var pageIndex = this.params.pageIndex +1;
        var totalPages = this.params.totalPages;
        var $that = this;
        if(pageIndex < totalPages){
            this.params.pageIndex = pageIndex;
            this.loadList(function () {
              setTimeout(function () {
                $that.$refs.loadmore.onBottomLoaded();
              });
            });
        }else{
            //已经全部请求
          this.params.bottomDropText = '已经最后一页了';
          $that.$refs.loadmore.onBottomLoaded();
        }
      },
      filterClick:function(e){
        var $that = this;
        var type = e.currentTarget.dataset.id;
        if(type == 1){
          this.params.servicestate = 1;
        }else if(type== 2){
          this.params.servicestate = 2;
        }else{
          this.params.servicestate = 0;
        }
        //sort


        this.selected = type;
        localStorage['selected'] = type;

        this.params.pageIndex = 0;
        this.list = [];
        this.loading = true;
        this.showLoading = true;
        this.loadList(function () {
          setTimeout(function () {
            $that.showLoading = false;
            $that.loading = false;
          },1500);
        });
      },
      // 按日期搜索
      getSearchClick:function(item){
        var date = item.date;
        var dateList = this.dateList;
        var dateList_new = dateList.map((item)=>{
            if(item.date &&(item.date == date)){
                item.on = true;
            }else{
                item.on = false;
            }
            return item;
        });
        this.dateList = dateList_new;
        this.params.servicestate = -1;
        this.params.pageIndex = 0;
        this.params.date = date;
        this.loadList();
      },
      todetails:function(msg){
        var id = msg.billid;
        // var selected = this.selected;
        var selected = msg.servicestate;
        if(selected >0){
          if(!id || ( selected < 1 ))return;
          var obj = {};
          obj.name = msg.name;
          obj.avatar = msg.avatar;
          obj.phone = msg.phone;
          obj.contactname = msg.contactname || msg.name;
          obj.contactphone = msg.contactphone || msg.phone;
          obj.billid = msg.billid;
          obj.agentid = msg.agentid;
          obj.surveydate=msg.surveydate;
          obj.dealid=msg.dealid;
          obj.totalamount = msg.totalamount;
          obj.servicestate = msg.servicestate;
          obj.customerid = msg.customerid;
          localStorage['obj'] = JSON.stringify(obj);
          // this.$router.push({path:'/details?id='+id });
          this.$router.push({path:'/imgupdate'});
        }
      },

      // 日历
      getImportant:function(){
        var $that = this;
        Indicator.open();
        this.$ajax.get(this.$$api.mobile.getServiceCalendar,{
          'month':$that.params.month
        },function (res) {
          if (res.status == 200) {
            var msg = res.data;
            $that.importantList = msg;
            $that.getCalendar();
          }
        });
      },
      openorclose:function(){
        this.params.pageIndex = 0;
        if(this.isShowdate){
          // this.params.date = this.getToday();
          this.params.date = '';
          this.isShowdate = false;
          this.params.servicestate = this.selected ;
          this.loadList();
        }else{
          Indicator.open();
          this.params.date = this.getToday();
          var date=new Date();            //定义一个日期对象；
          var year=date.getFullYear();    //获取当前年份；
          var month="0" +(date.getMonth()+1);    //获取当前月份；
          month = month.substring(month.length-2,month.length);
          //回填数据
          this.calendar.year = year;
          this.calendar.month = month;
          this.params.month = year+'-'+month;
          this.params.servicestate = -1;
          this.params.date = "";
          this.getImportant();
        }
      },
      prevClick:function(){
        this.$indicator.open();
        var year = this.calendar.year;
        var month = this.calendar.month;
        if(month==1){
          year--;
          month=12;
        }else{
          month--;
        }
        month = "0" + month;
        month = month.substring(month.length-2,month.length);
        this.calendar.year = year;
        this.calendar.month = month;
        this.params.month = year+'-'+month;
        this.params.pageIndex = 0;
        var d = new Date(year, month, 0).getDate();
        var d_temp = new Date(this.params.date).getDate();
        d = d_temp > d ? d : d_temp;
        d = "0" + d;
        d = d.substring(d.length-2,d.length);
        this.params.date = year +"-"+ month +"-"+ d;
        this.getImportant();
      },
      todayClick:function(){
        var date=new Date();            //定义一个日期对象；
        var year=date.getFullYear();    //获取当前年份；
        var month=date.getMonth()+1;    //获取当前月份；
        this.params.pageIndex = 0;
        //回填数据
        this.calendar.year = year;
        this.calendar.month = month;
        this.params.month = year+'-'+month;
        this.params.date = "";
        this.getImportant();
      },
      nextClick:function(){
        var year = this.calendar.year;
        var month = this.calendar.month;
        if(month==12){
          year++;
          month=1;
        }else{
          month++;
        }
        month = "0" + month;
        month = month.substring(month.length-2,month.length);
        this.calendar.year = year;
        this.calendar.month = month;
        this.params.month = year+'-'+month;
        this.params.pageIndex = 0;
        var d = new Date(year, month, 0).getDate();
        var d_temp = new Date(this.params.date).getDate();
        d = d_temp > d ? d : d_temp;
        d = "0" + d;
        d = d.substring(d.length-2,d.length);
        this.params.date = year +"-"+ month +"-"+ d;
        this.getImportant();
      },
      getCalendar:function(nian,yue,ri){
          // 计算本月1号是周几；
          var nian = this.calendar.year;
          var yue = this.calendar.month;
          var now = this.params.date || this.getToday();
          var week = new Date(nian+'-'+yue+'-1').getDay();
          //计算本月有多少天；
          var days = new Date(nian,yue,0).getDate();
          //计算上月有多少天；
          var dayw = new Date(nian,yue-1,0).getDate();

          var importantList = this.importantList;
          var dateList = [];
          //将日历填回页面；标记 日程
          for(var i=0,j=days;i<j;i++){
              var keys = Object.keys(importantList[i]);
              var obj = {};
              obj.date = keys[0];
              obj.is = importantList[i][keys[0]];
              obj.num = i+1;
              obj.isClick = true;
              if(keys[0] == now){
                obj.on = true;
              }
              dateList.push(obj);
          }
          //计算前面空格键；
          for(var i=dayw;i>=dayw-week+1;i--){
            var obj = {};
            obj.isClick = false;
            obj.num= i;
            obj.is= 'N';
            dateList.unshift(obj);
          }
          //计算后面空格键；
          // var after = 7 - (((week +days) % 7) ==0? 7 :((week +days) % 7));
          var after = 43-days-week;
          for(var i=1;i<after;i++){
            var obj = {};
            obj.isClick = false;
            obj.num= i;
            obj.is= 'N';
            dateList.push(obj);
          }
          this.dateList = dateList;
          this.isShowdate = true;
          // Indicator.close();
          this.params.date = now;
          this.loadList();
      },
      // comm
      getToday:function(val,type){
        var data = val;
        var arr = [];
        if(!val){
          data = new Date();
        }else{
          data = new Date(val);
        }
        arr[0] = data.getFullYear();
        arr[1] = "0" + (data.getMonth()+1);
        arr[2] = "0" + data.getDate();

        var str;
        arr[1] = arr[1].substring(arr[1].length-2,arr[1].length);
        arr[2] = arr[2].substring(arr[2].length-2,arr[2].length);
        if(type == 'month'){
          // str = arr[0] + '-' + (arr[1]<10?'0'+arr[1]:arr[1]);
          str = arr[0] + '-' + arr[1];
        }else{
          str = arr[0] + '-' + arr[1] + '-' + arr[2];
          // str = arr[0] + '-' +arr[1] +'-'+arr[2];
        }
        return str;
      },
      // 无限滚动
      scroll_load:function () {
        if(this.loading){
          return;
        }
        this.loading = true;
        this.showLoading = true;
        var $that = this;
        var pageIndex = $that.params.pageIndex;
        var totalPages = $that.params.totalPages;
        if(pageIndex >= totalPages){
          // 已经到最后一页了
          this.stopload = true;
          setTimeout(function () {
            $that.showLoading = false;
            $that.loading = false;
          },2500);
        }else{
          this.stopload = false;
          $that.loadList(function () {
            $that.showLoading = false;
            $that.loading = false;
          });
        }
      },
      // 接受、拒绝委派
      acceptClick:function(isAccept,billid) {
          var $that = this;
          if(!$that.acceptBool)return;
        if(isAccept == 'N'){
          this.$messagebox.confirm('确定要拒绝吗?').then(action => {
            if(action =='confirm'){
              $that.acceptBool = false;
              $that.$ajax.post($that.$$api.mobile.isaccept,{
                billid:billid,
                isAccept:isAccept,
                // memo:this.memo||'',
              },function (res) {
                $that.params.date = '';
                $that.params.pageIndex = 0;
                $that.isShowdate = false;
                $that.loadList();
                setTimeout(function () {
                  $that.acceptBool = true;
                },500)
              });
            }
          });
        }else{
          $that.$ajax.post($that.$$api.mobile.isaccept,{
            billid:billid,
            isAccept:isAccept,
            // memo:this.memo||'',
          },function (res) {
            $that.params.date = '';
            $that.params.pageIndex = 0;
            $that.isShowdate = false;
            $that.loadList();
          });
        }
      },

      // sort
      setSort:function (key,value) {
        var obj = this.sort;
        if(key){
          obj[key] = value;
        }
        this.sort = obj;
        localStorage['sort'] = JSON.stringify(obj);
      },
      getSort:function (key) {
        var obj = localStorage['sort'];
        if(obj){ this.sort = JSON.parse(obj);}
        if(key){ return obj[key]; }
      },
      selectSort:function (select) {
        console.log(222);
        let $that = this;
        setTimeout(()=>{
          $that.setSort('select',select);
        },200)
      },
      closeSort:function () {
        this.setSort('select', 0);
      },
      resetSort:function () {
        //重置
        this.setSort('state', '全部');
        this.setSort('stateNum', -1);
        this.setSort('time', '全部');
        this.setSort('timeNum', -1);
        this.setSort('search', '');
        this.setSort('orderbytime', '建单时间');
        this.setSort('orderbytimeNum', -1);
      },
      saveSort:function () {
        this.params.bottomDropText = '释放加载';
        this.params.pageIndex = 0;
        this.loadList();
        this.closeSort();
      },
      extendsSelect:function (type,name,num) {
        if(this.sort[type] == name){
          if(type!="orderbytime"){
            this.setSort(type,'全部');
          }else{
            this.setSort(type,'建单时间');
            this.setSort('orderbytimeNum',-1);
          }
          if(type=='state'){this.setSort('stateNum',-1);}
          if(type=='time'){this.setSort('timeNum',-1);}
        }else{
          this.setSort(type,name);
          if(type=='state'){this.setSort('stateNum',num);}
          if(type=='time'){this.setSort('timeNum',num);}
          if(type=='orderbytime'){this.setSort('orderbytimeNum',num);}
        }
        this.setSort();
      },
      //sort - - time
      sortTimeFilter:function (num) {
        let startTime,endTime;
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();

        endTime = this.sortFormat(year,month,day);

        //计算上月有多少天；
        let prevYear,prevMonth,prevDay;
        if(month>1){
          prevYear = year;
          prevMonth =  month -1;
        }else{
          prevYear = year -1;
          prevMonth = 12;
        }
        prevDay = new Date(prevYear,prevMonth,0).getDate();
        switch (num) {
          case 1 :
            //近七天
                startTime = this.getYearMonthDay(date,-6);
                break;
          case 2:
            //近15 天
            startTime = this.getYearMonthDay(date,-15);
            break;
          case 3:
            //本月
              startTime = this.sortFormat(year,month,1);
            break;
          case 4:
            //上个月
              startTime = this.sortFormat(prevYear,prevMonth,1);
              endTime = this.sortFormat(prevYear,prevMonth,prevDay);
            break;

        }
        //时间区间，不包括开始、结束的时间，前后需要加一天
        startTime = this.getYearMonthDay(startTime,-1);
        endTime = this.getYearMonthDay(endTime,1);
        return {
          starttime:startTime,
          endtime:endTime,
        };
      },
      getYearMonthDay:function(time,add){
        if(String(time).indexOf('-')>-1){
          time = time.replace(/-/g,'/');
        }
        var time = new Date(time);
        if(add){
          time = (time.getTime()) + add*24*60*60*1000;
          time = new Date(time);
        }
        let year = time.getFullYear();
        let month = time.getMonth()+1;
        let day = time.getDate();
        let val = this.sortFormat(year,month,day);
        return val;
      },
      sortFormat:function (year,month,day) {
        month = ('0'+ month ).substr(-2,2);
        day = ('0'+ day ).substr(-2,2);
        return year + '-' + month + '-' + day;
      },

      //toSearch
      toSearch:function () {
        // this.$router.push({path:'/search'});
        this.$router.push({name: "search",
          params: {
            'type': 'select',
            'api': 'getServiceList',
            'tips': '请输入手机号/姓名搜索',
            'title': '工程搜索',
            'val': '',
          }
        });
      },

    },
    created(){

    },

  }
</script>
<style scoped>
  .container{
    background: #f7f7f7;
  }
  ol,ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .iconfont{
    font-size: 7vw;
  }
  .mint-navbar{
    position: fixed;
    top: 9vh;
    left: 0;
    width: 100%;
    height: 7.5vh !important;
    z-index: 20;
  }

  /*日期*/
  .date{
    position: fixed;
    top: 9vh;
    left: 0;
    width: 100%;
    /*height: 42vh;*/
    background:#4B7299;
    color: #fff;
    z-index: 20;
  }
  .date ul li span{
    font-size: 4vw;
    color: red;
  }
  .date ol li,
  .date ul li{
    width: 14.28%;
    height: 8vw;
    /*line-height: 11.28vw;*/
    text-align: center;
    display: inline-block;
  }
  .date ul{
    background: #fff;
    color: black;
    border-bottom: 1px solid #ccc;
  }
  .date ul li.on{
    background: #000;
    color: #fff;
  }
  .date ul li div.sch{
    border-bottom: 1px solid #26a2ff;
  }
  .date ul li.on div.sch{
    /*text-decoration: underline;*/
    /*-moz-text-decoration-color:#26a2ff;*/
    /*text-decoration-color: #26a2ff;*/
    border-bottom: 1px solid #fff;
  }

  .around >div{
    border: 1px solid #ccc;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    width: 10vw;
    height: 10vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .opera>div>div{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    padding: 3vw 7.226vw;
    margin-top: 1.5vw;
    font-size: 3vw;
  }
  .c_size_15{
    font-size:4.2vw;
  }
  .c_size_12{
    font-size:3.7vw;
  }
  .c_size_12{
    font-size:3.5vw;
  }
  .form{
    margin:2vw 2vw 4vw;
    border-radius:1vw;
    position:relative;
    border:.2vw solid rgb(184,195,206);
    /*border:1px dotted rgb(3,162,228);*/
    padding:2vw;
    overflow: hidden;
  }
  .bg_gray_light{
   background: rgba(184,195,206,.7);
   border:none !important;
  }
  .info{
    width:100%;
  }
  .supper{
    position:absolute;
    top:2vw;
    right:0vw;
  }
  .c_gray_dark{
    color: rgb(108,125,135);
  }
  .code{ /*工程编号*/

  }
  /*接收拒绝*/
  .confirm{
    border-top:1px dashed rgba(184,195,206,.3);
    margin-top:2vw;
    width:100% !important;
  }
  .confirm>div{
    width:15vw;
    height:7vw;
    border-radius:5vw;
    text-align: center;
    padding:0 !important;
    line-height:7.5vw;
    margin-right:2vw;
    float:right;
  }

  .c_flex_between{
    display:flex;
    justify-content: space-between;
  }
  .inlineBlock{
    display:inline-block !important;
  }
  .new{ /*最新右上角角标*/
    position:absolute;
    top:1vw;
    right:-7vw;
    color:#fff;
    text-align:center;
    line-height:5vw;
    background:rgb(3,162,228);
    width:20vw;
    height:5vw;
    transform-origin: center center;
    transform: rotate(45deg);
  }

  /*排序*/
  .sort-body {
    position: fixed;
    left: 0;
    top: 16.5vh;
    height: 7vh;
    width: 100%;
    z-index: 21;
  }
  .sort-condition {
    box-sizing: border-box;
    padding: 2vw 0;
    overflow-x: auto;
  }
  .sort-condition .sort-condition-group{
    border-radius: 10px;
    border: 0;
    background: #f7f7f7;
    margin-left: 3vw;
    box-sizing: border-box;
    padding: 2vw 5vw;
    font-size: 3vw;
    position: relative;
    height: 4.5vh;
    transition: all linear 200ms;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    min-width: 37vw;
  }
  .sort-condition .sort-condition-group.on{
    color: #ff4949;
  }
  .sort-condition .sort-condition-group.et{
    color: #ff4949;
    height: 6vh;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .sort-extends{
    position: fixed;
    top: 23.5vh;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 22;
    transition: all linear 200ms;
  }
  .sort-extends-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 2px;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 22;
  }
  .sort-extends-body{
    position: absolute;
    width: 100%;
    height: 65vw;
    top: 0;
    left: 0;
    z-index: 25;
    background: #f7f7f7;
    overflow-x: hidden;
    overflow-y: auto;
    flex-wrap: wrap;
    /*justify-content: flex-start;*/
    align-content: flex-start;
  }
  .sort-extends-group.on{
    color: #f44336;
  }
  .sort-extends-group{
    box-sizing: border-box;
    padding: 5vw 10vw;
    margin-top: 2vw;
    width: 50vw;
    height: 7vw;
  }
  .sort-extends-opera{
    position: absolute;
    top: 65vw;
    left: 0;
    width: 100%;
    height: 10.5vw;
    z-index: 25;
    background: #fff;
    font-size: 3.5vw;
  }
  .sort-extends-opera div{
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
  }
  .sort-extends-body i.iconfont{
    font-size: 3vw;
  }

  .searchIcon i.iconfont{
    font-size: 5vw;
  }


  .sort-extends-input{
    width: 100%;
    outline: none;
    box-sizing: border-box;
    box-shadow: none;
    height: 100%;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid #f5f5f5;
  }
  .state_bg{
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 10px;
    border-radius: 25px;
    display: inline-block;
    background-color: rgba(255,0,0,0.7);
    font-size: 13px;
  }
  .state_bg.state_1{ background: red; }
  .state_bg.state_2{ background: orange; }
  .state_bg.state_3{ background: yellowgreen; }
  .state_bg.state_4{ background: green; }
  .state_bg.state_5{ background: darkcyan; }
  .state_bg.state_6{ background: blue; }
  .state_bg.state_7{ background: purple; }
  .state_bg.state_8{ background: deeppink; }
</style>



// WEBPACK FOOTER //
// src/components/main.vue